import { createFileRoute } from "@tanstack/react-router";
import TermsOfServicePage from "@/pages/legal/TermsOfServicePage";

export const Route = createFileRoute("/terms")({
  head: () => ({
    meta: [
        {
            "title": "Conditions d'utilisation | System Atlas"
        },
        {
            "name": "description",
            "content": "Conditions d'utilisation de System Atlas : règles d'usage, responsabilités, propriété des contenus et limitations."
        },
        {
            "property": "og:title",
            "content": "Conditions d'utilisation | System Atlas"
        },
        {
            "property": "og:description",
            "content": "Conditions d'utilisation de System Atlas : règles d'usage, responsabilités, propriété des contenus et limitations."
        },
        {
            "property": "og:type",
            "content": "website"
        },
        {
            "property": "og:url",
            "content": "https://systematlas.fr/terms"
        },
        {
            "property": "og:image",
            "content": "https://storage.googleapis.com/gpt-engineer-file-uploads/fixHLaYpiGQriTbTH3NKQDMP9X13/social-images/social-1776280806353-Screenshot_2026-04-15_at_21.19.52.webp"
        },
        {
            "name": "twitter:card",
            "content": "summary_large_image"
        },
        {
            "name": "twitter:title",
            "content": "Conditions d'utilisation | System Atlas"
        },
        {
            "name": "twitter:description",
            "content": "Conditions d'utilisation de System Atlas : règles d'usage, responsabilités, propriété des contenus et limitations."
        },
        {
            "name": "twitter:image",
            "content": "https://storage.googleapis.com/gpt-engineer-file-uploads/fixHLaYpiGQriTbTH3NKQDMP9X13/social-images/social-1776280806353-Screenshot_2026-04-15_at_21.19.52.webp"
        }
    ],
    links: [
        {
            "rel": "canonical",
            "href": "https://systematlas.fr/terms"
        }
    ],
  }),
  component: TermsOfServicePage,
});
